import {
  RECEIVE_IS_FETCHING_PICKUP_DATA,
  RECEIVE_PICKUP_FORM,
  RECEIVE_PICKUP_DATA_ERROR,
  RECEIVE_PICKUP_INSTRUCTIONS,
  RECEIVE_TOGGLE_PICKUP_INSTRUCTIONS,
  RECEIVE_PICKUP_PHONE_NUMBER,
  RECEIVE_PICKUP_PHONE_NUMBER_ERROR,
  RECEIVE_PICKUP_TIME_WINDOW,
} from '../../actions/pickup';
import { SELECT_RETURN_OPTION } from '../../actions/returnOptions';

export const initialState = {
  isFetching: false,
  service: '',
  form: {
    date: '',
    address: {},
    showInstructions: false,
    instructions: '',
    phoneNumber: '',
    phoneNumberError: false,
    pickupTime: '',
  },
  error: false,
};

export default (
  state = initialState,
  {
    type,
    data: {
      isFetching,
      service,
      form,
      instructions,
      phoneNumber,
      phoneNumberError,
      options,
      pickupTime,
    } = {},
  },
) => {
  switch (type) {
    case RECEIVE_IS_FETCHING_PICKUP_DATA:
      return {
        ...state,
        isFetching,
      };

    case RECEIVE_PICKUP_FORM:
      return {
        ...state,
        service,
        form: {
          ...state.form,
          ...form,
        },
        options,
        error: false,
      };

    case RECEIVE_PICKUP_DATA_ERROR:
      return {
        ...state,
        isFetching: false,
        error: true,
      };

    case RECEIVE_TOGGLE_PICKUP_INSTRUCTIONS:
      return {
        ...state,
        form: {
          ...state.form,
          showInstructions: !state.form.showInstructions,
          instructions: !state.form.showInstructions ? '' : state.form.instructions,
        },
      };

    case RECEIVE_PICKUP_INSTRUCTIONS:
      return {
        ...state,
        form: {
          ...state.form,
          instructions,
        },
      };

    case RECEIVE_PICKUP_PHONE_NUMBER:
      return {
        ...state,
        form: {
          ...state.form,
          phoneNumber,
        },
      };

    case RECEIVE_PICKUP_PHONE_NUMBER_ERROR:
      return {
        ...state,
        form: {
          ...state.form,
          phoneNumberError,
        },
      };

    case RECEIVE_PICKUP_TIME_WINDOW:
      return {
        ...state,
        form: {
          ...state.form,
          pickupTime,
        },
      };

    case SELECT_RETURN_OPTION:
      return { ...initialState };

    default:
      return state;
  }
};
